import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/data/site";
import { useT } from "@/i18n/I18nProvider";
import { useSite } from "@/i18n/useSite";
import { PageIntro, SectionHeading, Reveal } from "@/components/Section";
import { ServiceCard } from "@/components/ServiceCard";
import { Testimonials } from "@/components/Testimonials";
import { TalkCta } from "@/components/TalkCta";

export default function Services() {
  const t = useT();
  const { SERVICES } = useSite();
  return (
    <>
      <PageIntro eyebrow={t("Our services")} title={t("Support that fits")} accent={t("around your life.")} text={t("Eight flexible supports, delivered by consistent, caring workers — at home and in the community. Mix and match to suit your plan and your goals.")} image={IMAGES.dailyLife}>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/contact" className="btn btn-coral" data-testid="services-enquire">{t("Enquire About Support")} <ArrowRight size={16} /></Link>
          <Link to="/why-us" className="btn btn-ghost-blue" data-testid="services-why">{t("Why choose us")}</Link>
        </div>
      </PageIntro>
      <section className="py-16 lg:py-24 bg-[var(--blue-tint)]" data-testid="services-grid-section">
        <div className="container-x">
          <SectionHeading eyebrow={t("Everything we offer")} title={t("Choose the supports you need")} />
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {SERVICES.map((s, i) => <ServiceCard key={s.slug} s={s} i={i} featured />)}
          </div>
        </div>
      </section>
      <section className="py-16 lg:py-24">
        <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <Reveal><img src={IMAGES.community} alt={t("Community participation")} className="w-full h-[320px] lg:h-[400px] object-cover corner-tr corner-bl" style={{ borderRadius: "0 80px 0 80px" }} /></Reveal>
          <SectionHeading eyebrow={t("Inclusive by design")} title={t("Care that respects your culture, identity and choices")} text={t("We welcome people of all backgrounds and abilities. Every plan is built with you — respecting your values, language, beliefs and the way you like things done at home.")} />
        </div>
      </section>
      <Testimonials />
      <TalkCta sourcePage="services" />
    </>
  );
}
